export default __webpack_public_path__ + "static/media/people_type_older.69dea76c.svg";